import { connect } from 'react-redux'
import { withWizard } from 'react-albus'
import { setWizards, resetConfiguratorWizard } from 'core/components/wizard/actions'
import Configurator from './Configurator'

const mapStateToProps = state => ({
  wizards: state.wizards
})

const mapDispatchToProps = {
  setWizards,
  resetConfiguratorWizard
}

// For test.js
export const ConnectedConfigurator = connect(
  mapStateToProps,
  mapDispatchToProps
)(withWizard(Configurator))

export default withWizard(connect(mapStateToProps, mapDispatchToProps)(Configurator))
